import { createRouter, createWebHashHistory } from "vue-router";
import store from "../store/index.js";

import nprogress from "nprogress";
import { TokenManager } from "@/utils/axios-util.js";

const routes = [
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue")
  },
  {
    path: "/",
    redirect: {
      name: "home"
    }
  },
  // home
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/home.vue"),
    redirect: {
      name: "wood"
    },
    children: [
      {
        path: "wood",
        name: "wood",
        component: () => import("@/views/wood/wood.vue"),
        redirect: {
          name: "wood-index"
        },
        children: [
          {
            path: "wood/index",
            name: "wood-index",
            component: () => import("@/views/wood/wood-index.vue")
          },
          {
            path: "wood/appraisal/show/:woodAppraisalId",
            name: "wood-appraisal-show",
            component: () => import("@/views/wood/wood-appraisal-show.vue")
          },
          {
            path: "wood/feature",
            name: "wood-feature",
            component: () => import("@/views/wood/wood-feature.vue")
          },
          {
            path: "wood/image/upload/:woodAppraisalId",
            name: "wood-image-upload",
            component: () => import("@/views/wood/wood-image-upload.vue")
          }
        ]
      },
      {
        path: "user",
        name: "user",
        component: () => import("@/views/user/user.vue")
      }
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 全局前置守卫
router.beforeEach((to, from) => {

   if (!TokenManager.getToken()) {
    if (to.name !== "login") {
      return { name: "login" };
    }
  }
  // 进度条开始
  nprogress.start();
  if (from.meta.leaveScrollTop) {
    from.meta.leaveScrollTop.value = document.documentElement.scrollTop;
  }
});

// 全局后置钩子
router.afterEach((to, from) => {
  // 进度条完成
  nprogress.done();
  store.dispatch("changeBeforeRoute", from);
});

export default router;
